//

import { openDatabase } from './configDB';

export async function addIndexDBRecord(dbKey, record) {
  try {
    const db = await openDatabase();
    const tx = db.transaction(dbKey, 'readwrite');
    const store = tx.objectStore(dbKey);
    await store.add(record);

    await tx.done;
  } catch (error) {
    console.error(error);
  }
}

export async function getAllIndexDBRecords(dbKey) {
  let allRec = null;

  try {
    const db = await openDatabase();
    const tx = db.transaction(dbKey, 'readonly');
    const store = tx.objectStore(dbKey);
    allRec = await store.getAll();

    await tx.done;
  } catch (error) {
    console.error(error);
  }

  return allRec;
}

export async function updateIndexDBRecord(dbKey, records) {
  try {
    const db = await openDatabase();

    // Step 1: Clear all existing records first
    const clearTx = db.transaction(dbKey, 'readwrite');
    await clearTx.objectStore(dbKey).clear();
    await clearTx.done;

    // Step 2: Insert fresh records
    const writeTx = db.transaction(dbKey, 'readwrite');
    const store = writeTx.objectStore(dbKey);
    await Promise.all(records?.map((record) => store.put(record)));
    await writeTx.done;

    // Step 3: Update sync timestamp
    if (window.navigator.onLine) {
      const syncTx = db.transaction('syncReport', 'readwrite');
      await syncTx.objectStore('syncReport').put(new Date().toString(), dbKey);
      await syncTx.done;
    }

    console.log(`[IndexDB] ${dbKey} cleared and rewritten with ${records?.length} records`);
  } catch (error) {
    console.error('updateIndexDBRecord error:', error);
  }
}

export async function deleteIndexDBRecord(dbKey, recordId) {
  try {
    const db = await openDatabase();
    const tx = db.transaction(dbKey, 'readwrite');
    const store = tx.objectStore(dbKey);
    await store.delete(recordId);

    await tx.done;
  } catch (error) {
    console.error(error);
  }
}

export async function clearIndexDBStore(dbKey) {
  try {
    const db = await openDatabase();
    const tx = db.transaction(dbKey, 'readwrite');
    const store = tx.objectStore(dbKey);
    await store.clear();

    await tx.done;
  } catch (error) {
    console.error(error);
  }
}

//

export async function getIndexDBSingleRecord(dbKey, recordId) {
  let objectVal = null;

  try {
    const db = await openDatabase();
    const tx = db.transaction(dbKey, 'readonly');
    const store = tx.objectStore(dbKey);
    objectVal = await store.get(Number(recordId));
  } catch (error) {
    console.error(error);
  }

  return objectVal;
}

export async function getIndexDBSyncReport(objectKey) {
  let objectVal = null;

  try {
    const db = await openDatabase();
    const tx = db.transaction('syncReport', 'readonly');
    const store = tx.objectStore('syncReport');
    objectVal = await store.get(objectKey);
  } catch (error) {
    console.error(error);
  }

  return objectVal;
}
